export default __webpack_public_path__ + "assets/cbab9abd84aa793ff99183af5670e984.svg";